/* import __COLOCATED_TEMPLATE__ from './cx-score-display.hbs'; */
/* RESPONSIBLE TEAM: team-ai-insights */
import templateOnlyComponent from '@ember/component/template-only';
import type ConversationAttributeSummary from 'embercom/objects/inbox/conversation-attribute-summary';

interface Signature {
  Args: {
    cxExplanation: ConversationAttributeSummary['value'];
    cxScore: ConversationAttributeSummary['value'];
    hideCXWhenMissing?: boolean;
  };
}

const CxScoreDisplay = templateOnlyComponent<Signature>();
export default CxScoreDisplay;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Automation::AiInsights::CxScoreDisplay': typeof CxScoreDisplay;
    'reporting/automation/ai-insights/cx-score-display': typeof CxScoreDisplay;
  }
}
